// extracted by mini-css-extract-plugin
export default {"container":"GraphInfoTabs_container__+Bjtt","tab":"GraphInfoTabs_tab__vJqgL","active":"GraphInfoTabs_active__G6yH2"};